export default __webpack_public_path__ + "images/0x49e6a20f1bbdfeec2a8222e052000bbb14ee6007.png";